import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{'icon18/\u5370\u7AE0\u62BD\u53D6'}</title>
    <defs>
      <radialGradient
        cx="11.3172631%"
        cy="2.52121261%"
        fx="11.3172631%"
        fy="2.52121261%"
        r="124.298356%"
        id="GFJIFwOhODs7W9w62fZBQ__radialGradient-1"
      >
        <stop stopColor="#AFB8FF" offset="0%" />
        <stop stopColor="#7B46EC" offset="100%" />
      </radialGradient>
      <linearGradient
        x1="100%"
        y1="100%"
        x2="9.91935873%"
        y2="3.06161084%"
        id="GFJIFwOhODs7W9w62fZBQ__linearGradient-2"
      >
        <stop stopColor="#CDC2FF" offset="0%" />
        <stop stopColor="#EDEAFE" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="109.459011%"
        y1="47.3726218%"
        x2="-21.7299389%"
        y2="45.2954861%"
        id="GFJIFwOhODs7W9w62fZBQ__linearGradient-3"
      >
        <stop stopColor="#BCB1FE" offset="0%" />
        <stop stopColor="#FFFFFF" offset="100%" />
      </linearGradient>
    </defs>
    <g
      id="GFJIFwOhODs7W9w62fZBQ__icon18/\u5370\u7AE0\u62BD\u53D6"
      stroke="none"
      strokeWidth={1}
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="GFJIFwOhODs7W9w62fZBQ__\u77E9\u5F62"
        fill="url(#GFJIFwOhODs7W9w62fZBQ__radialGradient-1)"
        x={0}
        y={0}
        width={18}
        height={18}
        rx={2}
      />
      <path
        d="M9,2 C12.8659932,2 16,5.13400675 16,9 C16,12.8659932 12.8659932,16 9,16 C5.13400675,16 2,12.8659932 2,9 C2,5.13400675 5.13400675,2 9,2 Z M9,4 C6.23857625,4 4,6.23857625 4,9 C4,11.7614237 6.23857625,14 9,14 C11.7614237,14 14,11.7614237 14,9 C14,6.23857625 11.7614237,4 9,4 Z"
        id="GFJIFwOhODs7W9w62fZBQ__\u692D\u5706\u5F62"
        fill="url(#GFJIFwOhODs7W9w62fZBQ__linearGradient-2)"
      />
      <polygon
        id="GFJIFwOhODs7W9w62fZBQ__\u661F\u5F62"
        fill="url(#GFJIFwOhODs7W9w62fZBQ__linearGradient-3)"
        points="9 10.5 7.23664424 11.427051 7.57341523 9.46352549 6.14683045 8.07294902 8.11832212 7.78647451 9 6 9.88167788 7.78647451 11.8531695 8.07294902 10.4265848 9.46352549 10.7633558 11.427051"
      />
    </g>
  </svg>
);
const Memo = memo(Icon);
export default Memo;
